
// @ts-nocheck


export const localeCodes =  [
  "en",
  "zh"
]

export const localeLoaders = {
  "en": [{ key: "../i18n/locales/en.json", load: () => import("../i18n/locales/en.json" /* webpackChunkName: "locale__var_www_lottobox_agent_i18n_locales_en_json" */), cache: true }],
  "zh": [{ key: "../i18n/locales/zh.json", load: () => import("../i18n/locales/zh.json" /* webpackChunkName: "locale__var_www_lottobox_agent_i18n_locales_zh_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "onlyLocales": [
      "en",
      "zh"
    ]
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "name": "English",
      "files": [
        "/var/www/lottobox-agent/i18n/locales/en.json"
      ]
    },
    {
      "code": "zh",
      "name": "中文",
      "files": [
        "/var/www/lottobox-agent/i18n/locales/zh.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "./i18n/locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "config",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "legacy": false,
  "globalInjection": true,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "files": [
      {
        "path": "/var/www/lottobox-agent/i18n/locales/en.json"
      }
    ]
  },
  {
    "code": "zh",
    "name": "中文",
    "files": [
      {
        "path": "/var/www/lottobox-agent/i18n/locales/zh.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
